<template>
  <v-app class="main" v-scroll="onScroll">
    <div id="about">
      <Home />
    </div>
    <Ethos id="ethos"/>
    <Focus id="focus"/>
    <Contact id="contact" />


    <div class="routes" ref="routepanel" @click="dummyClick()">
      <div class="center-container">
        <v-row class="center-v">
          <v-col>
            <v-row v-for="(route, i) in routes" style="height:80px" :key="i">
              <v-col>
                <v-tooltip left color="#F06292" :value="route.show">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" dark v-bind="attrs" v-on="on"
                      :color="i == selectedRoute ? '#2196f3' : '#2196f344'" style="background:rgba(64,64,64,0.1)" fab icon
                      :ref="'button' + i" @click="nav(route, i)" @touchstart="hideFocus(route, i)" @touchend="hideFocus(route, i)" @tap="hideFocus(route, i)"><v-icon
                        size="32">mdi-circle</v-icon></v-btn>
                  </template>
                  <span>
                    <h3>{{ route.title }}</h3>
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="social-icons">
      <v-btn
        elevation="0"
        fab
        icon
        color="#ffffff"
        @click="() => { window.open('https://www.linkedin.com/in/craighaworth/', '_blank'); }"
      ><v-icon size="32" >mdi-linkedin</v-icon></v-btn>
      <v-btn
        elevation="0"
        fab
        icon
        color="#ffffff"
        @click="() => { window.open('mailto:craig.haworth@loomitech.co.za', '_blank'); }"
      ><v-icon size="32" >mdi-email</v-icon></v-btn>
      <v-btn
        elevation="0"
        fab
        icon
        color="#ffffff"
        @click="() => { window.open('tel:+27720121187'); }"
      ><v-icon size="32" >mdi-phone</v-icon></v-btn>
      <v-btn
        elevation="0"
        fab
        icon
        color="#ffffff"
        @click="() => { window.open('https://www.facebook.com/loomitechdesigner', '_blank'); }"
      ><v-icon size="32" >mdi-facebook</v-icon></v-btn>
    </div>
  </v-app>
</template>

<script>

import smoothscroll from 'smoothscroll-polyfill';
import Home from './components/views/Home.vue'
import Contact from './components/views/Contact.vue'
import Ethos from './components/views/Ethos.vue'
import Focus from './components/views/Focus.vue'

smoothscroll.polyfill();

export default {
  components: {
    Home,
    Contact,
    Ethos,
    Focus
  },
  data: () => ({
    selectedRoute: 0,
    routes: [
    { title: 'about', hash: 'about', show: false },
      { title: 'ethos', hash: 'ethos', show: false },
      { title: 'focus', hash: 'focus', show: false },
      { title: 'contact', hash: 'contact', show: false },
    ],
    webfiles: [
      '/img/easefica-4.png',
      '/img/easefica-3.png',
      '/img/easefica-2.png',
      '/img/easefica-1.png',
    ]
  }),

  methods: {
    scrollFix: function (hashbang) {
      location.hash = hashbang;
    },
    offset: (el) => {
      if (!el) return null;
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    },
    isMobile() {
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              return true
          } else {
              return false
          }
      },
    
    nav(route,i) {
      this.selectedRoute = i;
      let e = document.getElementById(route.hash);
      e.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
        inline: 'start'
      });
    },
    hideFocus(route,i) {
      setTimeout(()=>{
        this.$refs['button'+i][0].$el.blur();
        let event = new Event("touchstart");
        this.$refs.routepanel.dispatchEvent(event);
        //this.$refs.routepanel.fire('touchstart');
        route.show=false;
        console.log('touch start event');
      },1000);
    },
    dummyClick() {

    },
    isInViewport(element) {
        const rect = element.getBoundingClientRect();
        /*return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );*/
        return rect.top < ((window.innerHeight || document.documentElement.clientHeight) / 2)
    },

    onScroll() {
      if(this.snapping) return;
      this.routes.map( (route,i) => {
        let e = document.getElementById(route.hash);
        if(this.isInViewport(e)) {
          this.selectedRoute = i;
          return;
        }
      });
    }
  },
  computed:
  {
    window() { return window; }
    ,
    theme() {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  mounted() {
    setTimeout(()=>{
      this.routes.map((route,i)=>{
        setTimeout(()=>{
          route.show=true;
          setTimeout(()=>{
            route.show=false;
          },500)
        },500*i)
      });
    },1000);
  }
}
</script>

<style lang="scss">
p {
  font-size: 18px;
  color: #b1b1b1
}

.logo-image {
  width: 100%;
  animation: fadeInUp;
  /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s;
  /* don't forget to set a duration! */
  text-align: left;
  padding-left: 2%;
  margin-top: 24px;
}

body::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
body {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.theme--dark.v-application {
  background-color: transparent !important;
  background-size: 100% 100%;
  background-position: center;
}

@font-face {
  font-family: "Walkway Black";
  src: local("Walkway Black"),
    url("./assets/fonts/Walkway Black.ttf") format("truetype");
}

@font-face {
  font-family: "Walkway SemiBold";
  src: local("Walkway SemiBold"),
   url("./assets/fonts/Walkway SemiBold.ttf") format("truetype");
}

#app {
  font-family: "Walkway SemiBold";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.black-on-white {
  color: #161616 !important;
  background-color: white !important;
  animation: fadeInUp;
  /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s;
  /* don't forget to set a duration! */
}

h2 {
  font-family: "Walkway Black", Helvetica, Arial;
  font-size: 52px;
  font-weight: lighter;
  line-height: 56px;
}

h3 {
  font-family: "Walkway Black", Helvetica, Arial;
  font-size: 38px;
  font-weight: lighter;
  line-height: 40px;
}

h4 {

  font-size: 24px;
  font-weight: lighter;
  line-height: 28px;
  margin-top: 8px;
  margin-bottom: 16px;
}

.main {}

.v-main {
  padding-top: 0px !important;
}

.theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--dark.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-btn,
.theme--dark.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-tab {
  font-family: "Walkway Black", Helvetica, Arial;
  font-size: 18px !important;
}

html {
  scroll-behavior: smooth !important;
}

.header-watermark {
  font-size: 300px;
  line-height: 300px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.05);
  margin-bottom: -100px;
  margin-top: 64px;
}

.info-col-padding {
  padding: 64px !important;
}

.info-col-padding-2 {
  padding: 96px !important;
}

.main-logo {
  width: 50vw;
}

.main-tagline {
  color: #42a5f5;
  position: fixed;
  left: 30%;
  top: 55%
}

.routes {
    width: 56px;
    position: fixed;
    right:16px;
  }

@media (max-width: 960px) {
  .info-col-padding {
    padding: 16px !important;
  }

  .info-col-padding-2 {
    padding: 24px !important;
  }

  .header-watermark {
    font-size: 200px;
    line-height: 200px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: -64px;
    margin-top: 128px;
  }
}

@media (max-width: 600px) {
  .info-col-padding {
    padding: 16px !important;
  }

  .info-col-padding-2 {
    padding: 24px !important;
  }

  .v-tab {
    font-size: 12px !important;
  }

  .main-logo {
    width: 90vw;
  }

  .main-tagline {
    color: #72d2f6;
    position: fixed;
    left: 10%;
    top: 75%;
    font-size: 32px;
    line-height: 32px;
    padding-right: 64px;
  }

  .header-watermark {
    font-size: 100px;
    line-height: 100px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: 0px;
    margin-top: 128px;
  }

  .logo-text {
    font-size: 24px;
    margin-top: 24px;
    line-height: 24px;
  }

}


.right {
  text-align: right;
}

.left {
  text-align: left;
}



.full-screen {
  height: 100vh;
  min-height:800px;

}

.social-icons {
  position: fixed;
  right:32px;
  top:32px;
}

.routes {
  width: 56px;
  position: fixed;
  right:32px;
}

.center-container {
  position: relative;
  width:100%;
  height: 100vh;
}

.center-v {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

@media (max-width: 600px)  {
  .watermark {
    font-size:128px;
    line-height: 138px;
    max-width:375;
  }

  .watermark-black {
    font-size:128px;
    line-height: 138px;
    max-width:375;
  }

  .routes {
    width: 56px;
    position: fixed;
    right:16px;
  }

  .social-icons {
    position: fixed;
    right:16px;
    top:32px;
  }
}

</style>
